import styled from 'styled-components';
import {
  variant, layout, typography, color, compose, space, flex,
} from 'styled-system';

const Button = styled.button`
  padding: 8px 16px;
  text-transform: uppercase;
  letter-spacing: .09em;
  border-radius: 2px;
  
  appearance: none;
  font-size: 1rem;
  font-family: inherit;
  cursor: pointer;
  border-width: 2px;
  border-style: solid;
  border-color: ${(props) => props.theme.colors.button} ;
  
  &:hover {opacity: .8};
  
  &:disabled {
    opacity: .3;
    cursor: initial;
  };
  
  background-color: ${(props) => props.theme.colors.button};
  color: ${props => props.theme.colors.buttonText};
  ${(props) =>
  variant({
    prop: 'variant',
    variants: {
      solid: {
        backgroundColor: props.backgroundColor,
      },
      outlined: {
        backgroundColor: 'transparent',
        borderColor: props.backgroundColor,
        color: props.backgroundColor,
        borderWidth: '2px',
        borderStyle: 'solid'
      },
      text: {
        backgroundColor: 'transparent',
        border: 'none',
        color: props.theme.colors.button,
      }
    },
  })}
  
  ${compose(layout, color, typography, space, flex)}
`;

Button.defaultProps = {
  variant: 'solid',
};

export const CTAButton = styled(Button)`
  appearance: none;
  width: 100%;
  border: none;
  background-color: ${props => props.theme.colors.active};
  color: ${props => props.theme.colors.buttonText};
  padding: .5em 1em;
  text-decoration: none;
  text-align: center;
`

export default Button;